/**
 * A legacy device bag (`tabletStyles`, `mobileStyles`) that exists but holds `null`, `undefined` or `''`
 * for a key is the old panels' doing: their FormGroups carried every key and saved the ones nobody set on
 * that device as empty. The old renderer turned such a key into an invalid declaration (`nullpx`, an empty
 * colour), the browser dropped it and the desktop rule showed through. v0 has no cascade, so the desktop
 * value is taken here instead.
 */
const isUnset = (value: unknown): boolean => value == null || value === '';

export const legacyDeviceValue = <T>(device: unknown, desktop: T): T => (isUnset(device) ? desktop : (device as T));

/** Same, for a value the renderer suffixed with `px` — anything that does not parse was just as invalid. */
export const legacyDeviceNumber = (device: unknown, desktop: number): number => {
    const parsed = Number(device);

    return isUnset(device) || !Number.isFinite(parsed) ? desktop : parsed;
};
